export const beginDateFormat = 'YYYY-MM-DDT00:00:00.000ZZ';
export const endDateFormat = 'YYYY-MM-DDT23:59:59.999ZZ';
